<template>
  <!-- section wrapper -->
<section class=" wrapper-background">
    <!-- section 21 -->
    <section class="flexmobile2 mt-20 md:mt-44 mx-auto px-20 ">
    <section class="flex flexmobile2 flex-col items-start px-14 w-full  max-md:px-5 max-md:pb-24 max-md:max-w-full">
      <h1 class="font-semibold pt-10 md:pt-20 text-2xl md:text-4xl text-white -ml-16">Wireframe Iterations & Design Recommendations</h1 >
      <p class="pt-6 text-lg md:pt-10 text-white -ml-16">Based on the results from tree tests, certain iterations were made to the wireframes in order to simplify user interaction.</p>
      <p class="text-amber-100 text-2xl md:text-3xl dancing-script font-semibold pt-6 md:pt-10">Task 1 Wireframe: Business Interaction</p>
      <p class="text-amber-100 text-2xl md:text-3xl font-semibold pt-6">"Finding Job Openings"</p>
      <p class="font-semibold text-amber-50 dancing-script pt-6 text-2xl md:pt-10 pb-6 md:pb-6"> Current Website Navigation:</p>
      
      <div class="self-center mt-8 w-full max-w-[1292px] max-md:mt-10 max-md:max-w-full">
        <div class="flex gap-5 max-md:flex-col">
          <article class="flex flex-col w-[33%] max-md:ml-0 max-md:w-full">
            <p class="pt-6 text-lg md:pt-16grow px-16 py-12 w-full font-semibold text-center text-black bg-amber-50 rounded-xl max-md:px-5 max-md:mt-10">
              Does not catch immediate attention
            </p>
          </article>
          <article class="flex flex-col ml-5 w-[33%] max-md:ml-0 max-md:w-full">
            <p class="pt-6 text-lg md:pt-16grow px-16 py-12 w-full font-semibold text-center text-black bg-amber-50 rounded-xl max-md:px-5 max-md:mt-10">
              Makes the user scroll through all available options
            </p>
          </article>
          <article class="flex flex-col ml-5 w-[33%] max-md:ml-0 max-md:w-full">
            <p class="pt-6 text-lg md:pt-16grow px-16 py-12 w-full font-semibold text-center text-black bg-amber-50 rounded-xl max-md:px-5 max-md:mt-10">
              The filter/sort options is time consuming and hard to use.
            </p>
          </article>
        </div>
      </div>
      <div class="self-center mt-12 mb-0 w-full max-w-[1295px] max-md:mt-10 max-md:mb-2.5 max-md:max-w-full">
        <div class="flex gap-5 max-md:flex-col">
          <figure class="flex flex-col w-[33%] max-md:ml-0 max-md:w-full">
            <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/26c85f79f1d6baa5a7b4c2229bb111ebdd14cc9dbbcedc411e06958ffd956d31?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Current website navigation example 1" class="object-contain grow w-full aspect-[0.46] rounded-[30px] max-md:mt-10" />
          </figure>
          <figure class="flex flex-col ml-5 w-[33%] max-md:ml-0 max-md:w-full">
            <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/b9825d4ab5441931e747255f23308fd13525081df894aec15c0f1898fe8a27d6?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Current website navigation example 2" class="object-contain grow w-full aspect-[0.46] rounded-[30px] max-md:mt-10" />
          </figure>
          <figure class="flex flex-col ml-5 w-[33%] max-md:ml-0 max-md:w-full">
            <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/db934b092ee6ef9987afa4c0298def736e875c0f0d98b0749b02f4916a6fce80?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Current website navigation example 3" class="object-contain grow w-full aspect-[0.46] rounded-[30px] max-md:mt-10" />
          </figure>
        </div>
      </div>
    </section>
   <p class="font-semibold text-amber-50 dancing-script pt-6 text-2xl md:pt-16 pb-6 md:pb-6"> Design Recommendation:</p>
    <section class="flex flexmobile2 mt-4 flex-col rounded-none">
    <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726866010/Group_34211_1_bfz2mh.png" class="object-contain mt-9 md:w-full aspect-[1.25] rounded-[30px] max-md:max-w-full" alt="Job search features illustration" />
</section>
<section class="flex flexmobile2 mt-20 flex-col rounded-none">
    <main class="flex flexmobile2 flex-col items-start rounded-none">
        <header class="z-10 dancing-script mt-24 text-2xl font-semibold text-amber-50">
            <p class="text-amber-100 text-2xl md:text-3xl dancing-script font-semibold pt-6">Task 2 Wireframe: Learning about Loréal</p>
        </header>
         <p class="text-amber-100 text-2xl md:text-3xl font-semibold pt-6 md:pt-8">"Eco-friendly Initiatives"</p>
        <section class="flex flexmobile2 flex-col pl-5 mt-20 max-md:mt-10 max-md:max-w-full">
            
      <p class="font-semibold text-amber-50 dancing-script text-2xl -mt-4 pb-6 md:pb-6"> Current Website Navigation:</p>
            <div class="flex flex-wrap gap-10 self-end mt-8 w-full text-xl font-semibold text-black">
                <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726866330/Group_34212_1_ohqz7r.png" alt="Current website navigation illustration" class="object-contain grow shrink-0 aspect-[2.34] basis-0 rounded-[30px] w-fit max-md:max-w-full" />
               
            </div>
            <p class="font-semibold text-amber-50 dancing-script pt-6 text-2xl md:pt-16 pb-6 md:pb-6"> Design Recommendation:</p>
            <div class="self-center flexmobile2 mt-14 ml-24 max-w-full md:w-[1034px] max-md:mt-10">
                <div class="flex gap-5 max-md:flex-col">
                    <div class="flex flex-col w-2/5 max-md:ml-0 max-md:w-full">
                        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/acfbea5e02b2f322c0c8273b65dfc2e897d0386433ada2a39c9aa5f52fea9707?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Design recommendation illustration" class="object-contain grow w-full aspect-[0.42] rounded-[30px] max-md:mt-10" />
                    </div>
                    <div class="flex flex-col ml-5 w-3/5 max-md:ml-0 max-md:w-full">
                        <div class="grow max-md:mt-10 max-md:max-w-full">
                            <div class="flex gap-5 max-md:flex-col">
                                <div class="flex flex-col w-[63%] max-md:ml-0 max-md:w-full">
                                    <div class="flex relative flex-col pt-56 w-full aspect-[0.402] pb-[649px] rounded-[30px] max-md:py-24">
                                        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/c5b13f4f855745fa74748f9c6cb486ecd2bbff41ec16ab92c1ff492822fc45c0?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Design recommendation detail" class="object-cover absolute inset-0 size-full" />
                                        <div class="flex relative gap-5 justify-between max-md:-mr-1.5">
                                            <button class="flex shrink-0 h-14 rounded-full border-red-600 border-solid border-[5px] w-[57px]" aria-label="Previous page"></button>
                                            <button class="flex shrink-0 w-14 h-14 rounded-full border-red-600 border-solid border-[5px]" aria-label="Next page"></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex flex-col ml-5 max-md:ml-0 max-md:w-full">
                                    <div class="flex flex-col mt-60 text-xl font-semibold text-black max-md:mt-10">
                                        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/d05fed80d6c51b2402bf30193490ef9671caff61223cefd6eb674f6cfa345978?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b" alt="Navigation arrows illustration" class="object-contain z-10 max-w-full aspect-[1.13] w-[137px]" />
                                        <p class="self-end px-6 pt-3.5 pb-6 -mt-1.5 max-w-full bg-amber-50 rounded-xl w-[175px] max-md:pr-5">
                                            Users can toggle between pages using these arrows, allowing them to see related content faster.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</section>

   </section>
    <!-- section 1 -->
    <section class="mx-auto flexmobile2 mt-44 text-amber-50 px-20">
     <h1 class="text-white font-semibold text-2xl md:text-4xl">Chalkmark Test</h1>
      <p class="pt-6 text-lg md:pt-16">
        The aim was to see
        <span class="text-amber-100"> users’ first assumptions </span> to how a task might work.
      </p>
      <p class="pt-6 text-lg ">Tested Task 2 (Business Interaction Task).</p>
      <p class="dancing-script text-2xl md:text-3xl font-semibold pt-6 md:pt-8 ml-12">Task Promptt</p>
      <p class="ml-12 pt-6 text-lg md:pt-10">
        You believe working with L'Oréal would be an opportunity to introduce
        creativity into your work. Where would look search for job openings?
      </p>
    </section>
</section>
    <!-- section 2 -->
    <section class="container background-lor flexmobile2 md:mt-12 md:h-[500px] mx-auto px-20 ">
      <section
        v-if="isVisible"
        class="w-full flexmobile2 flex justify-center text-center h-[265px]  transition transform duration-500 ease-in-out"
        :class="{'opacity-0 scale-0': !inView, 'opacity-100 scale-100': inView}"
        ref="popupSection"
      >
        <div class="text-white text-center text-sm md:text-4xl mt-20">
      <p class="dancing-script mb-1 md:mb-6">Results</p>
      <ul class=" flex justify-between gap-10 dancing-script md:text-4xl text-white mt-16">
        <li>Participants       <span class=" montserrat font-bold">:21</span></li>
        <li>Successes              <span class=" montserrat font-bold">:19</span></li>
        <li>Fails  <span class=" montserrat font-bold">:2</span></li>
      </ul>
    </div>
      </section>
    </section>
    <!-- section 3 -->
    <section
      class="container flex justify-center flexmobile2 md:mt-4 mx-auto px-20"
      :class="{'animate__animated animate__bounceIn': inViewSection3}" 
      ref="section3"
    >
      <img loading="lazy" class="md:h-[60%] w-[50%]" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726660447/Group_34223_baa0uz.png" alt="">
    </section>
    <!-- section 4 -->
    <section class="px-20 flex flex-col justify-center  text-white flexmobile2 mx-auto mt-60">
      <h1 class="text-white font-semibold text-2xl md:text-4xl">Improvements & Suggestions</h1>
      <p class="pt-6 text-lg md:pt-16">
       <span class=" text-amber-100"> Increase the participant pool </span> and number of <span class=" text-amber-100">iterations</span> based on feedback.</p>
      <p class="pt-6 text-lg ">To yield better results for the task 3, the <span class=" text-amber-100">categories could be refined</span> and tested in the <span class=" text-amber">tree tests.</span></p>
      <p class=" pt-6 text-lg ">More <span class=" text-amber-100"> Chalkmark tests</span> could be  conducted and analyzed to improve the usability of the website.</p>
      
        <div class="flex  justify-center">
        <div class=" w-6xl md:mt-32 flex justify-self-center">
        <a
            href="https://online.fliphtml5.com/kqzee/vzyr/#p=1"
              class="flex   relative p-10  bgColorr  md:top-2 md:mt-24  md:w-46 h-12 text-center text-xl rounded-[80px] shadow-[0px_4px_24px_rgba(0,0,0,0.5)]"
            >
              <span class="grow text-white relative bottom-4 text-center ">Access Project Report</span>
            </a>
      </div>
       </div>
       <section class=" flex flexmobile2 md:mb-96 relative md:top-72 justify-center flex-col flex-wrap mt max-md:mt-10">
        <h2 class="md:text-4xl text-center font-semibold text-white">View other Projects</h2>
        <div class="self-start  ml-4 max-md:max-w-full">
          <div class="flex justify-center  gap-5 max-md:flex-col">
          <article class="flex  w-full max-md:ml-0 max-md:w-full">
              <div class="pb-12 flex flex-col md:flex-row justify-between items-center font-bold text-white rounded-[50px] max-md:px-5 max-md:mt-10 max-md:max-w-full">
                <router-link to="NextProject">
        <div class="flex cursor-pointer relative md:mt-20 z-10 w-full max-w-full max-md:w-full max-md:h-auto ">
            <img loading="lazy" class="w-full h-full object-cover" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726864991/Group_34207_1_t8ptsv.png" alt="">
        </div>
    </router-link>
                <router-link to="WangosProject">
        <div class="flex cursor-pointer  relative z-10 w-full max-w-full max-md:w-full max-md:h-auto">
            <img loading="lazy" class="w-full h-full object-cover" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726678071/Group_34202_jsapnl.png" alt="">
        </div>
    </router-link>
    
</div>
            </article>
          </div>
        </div>
      </section>
    </section>
  </template>
  
  <script>
  export default {
    name: "LorealProjectFour",
    data() {
      return {
        inView: false, // Track if section 2 is in view
        inViewSection3: false, // Track if section 3 is in view
        isVisible: true, // Control visibility of section 2
      };
    },
    mounted() {
      // Initialize IntersectionObserver for section 2
      const observerSection2 = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.inView = entry.isIntersecting;
        });
      });
  
      // Observe section 2
      observerSection2.observe(this.$refs.popupSection);
  
      // Initialize IntersectionObserver for section 3
      const observerSection3 = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.inViewSection3 = true; // Trigger animation when section 3 is in view
          }
        });
      });
  
      // Observe section 3
      observerSection3.observe(this.$refs.section3);
    },
  };
  </script>
  
  <style>
  .wrapper-background{
    background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726865141/Group_34221_xyebse.png");
    background-size:cover;


  }
  </style>
  